export function createConditionsPage() {
  return {
    template: `
      <div class="page-shell">
        <header class="brand-header">
          <a href="/" class="brand-mark brand-mark-link" aria-label="Bazis Motors">
            <img src="/images/logo_bazis_8.png" alt="БАЗИС МОТОРС" class="brand-logo" />
            <span class="brand-program-label">Реферальная программа</span>
          </a>
          <nav class="brand-nav">
            <a href="/">Форма регистрации</a>
            <a href="/conditions" class="is-active">Условия программы</a>
          </nav>
        </header>

        <section class="hero-card hero-card--bazis">
          <div class="hero-copy">
            <span class="eyebrow eyebrow--red">Agent BZS</span>
            <h1>Условия участия</h1>
            <p>
              Участником может стать клиент БАЗИС МОТОРС, ранее совершивший покупку автомобиля
              в одном из наших автосалонов или обслуживающийся в наших сервисных центрах.
            </p>
          </div>
          <div class="hero-badge hero-badge--money">
            <strong>15 000 ₽</strong>
            <span>вознаграждение за подтвержденную рекомендацию</span>
          </div>
        </section>

        <section class="conditions-grid">
          <a-card class="brand-card" :bordered="false" title="Как это работает">
            <ol class="conditions-list">
              <li>Отправьте контакты знакомых, которым вы уже рассказали о нашем автосалоне.</li>
              <li>Передавайте клиента до его визита в салон и до появления в нашей системе.</li>
              <li>Перед отправкой убедитесь, что человек согласен на передачу контактов и обратную связь.</li>
              <li>Если номер был передан после обращения клиента в компанию, программа не сработает.</li>
            </ol>
          </a-card>

          <a-card class="brand-card" :bordered="false" title="Основные требования">
            <ul class="conditions-list">
              <li>Контакты должны принадлежать реальному потенциальному покупателю.</li>
              <li>ФИО и номер телефона нужно указывать корректно и полностью.</li>
              <li>Повторная отправка одного и того же клиента не увеличивает вознаграждение.</li>
              <li>Бонус выплачивается после подтверждения сделки по вашей рекомендации.</li>
            </ul>
          </a-card>
        </section>

        <section class="brand-info-panel">
          <div class="brand-info-panel__copy">
            <h2>Когда выплачивается вознаграждение</h2>
            <p>
              Выплата производится после того, как клиент подтвержден, а сделка завершена
              и принята к учету компанией. Сроки и способ выплаты определяются внутренним регламентом.
            </p>
          </div>
          <div class="brand-info-panel__aside">
            <p><strong>Контроль заявок</strong></p>
            <p>Все обращения сохраняются в системе с указанием канала: сайт, Telegram или VK.</p>
          </div>
        </section>
      </div>
    `,
  };
}
